import React from 'react'
import './App.css'
import Subsection from './Subsection.js'
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import {notification} from 'antd'


const StyledTableCell = withStyles((theme) => ({
	head: {
	  backgroundColor: theme.palette.common.black,
	  color: theme.palette.common.white,
	},
	body: {
	  fontSize: 14,
	},
  }))(TableCell);
  
  const StyledTableRow = withStyles((theme) => ({
	root: {
	  '&:nth-of-type(odd)': {
		backgroundColor: '#eceff1',
	  }
	}, hover: {
		'&:hover': {
			backgroundColor: '#e3f2fd !important'
		}
	}
  }))(TableRow);

class Section extends React.Component {

	render() {
		const openNotification1 = (message, placement="bottomRight") => {
			notification["error"]({
			  message: 'Prerequisite not met',
			  description:
				'You have not met the pre-requisites required for this course. Make sure you completed the pre-requisites before enrolling.',
			  placement,
			});
		  };

		// generate each sections
		function generateSections(sectArray, name, num, callbackFromSection, courseKey, addCartCourse, propsComp, propsReq, propsData) {
			var arr = [];
			// generate the time
			function stringifyTime(timeArray) {
				var timeArr = [];
				arr = Object.entries(timeArray);
				arr.map((t, idx) => {
					timeArr.push(<div key={idx}>{t[0].charAt(0).toUpperCase() + t[0].slice(1) + ": " + t[1]}<br></br></div>);
				})
				return timeArr;
			}
			
			// generate the rows for the sections
			var rows = [];
			const bold = {fontWeight: 'bold'} //style for sections
			sectArray.map((sect, idx) => {
				rows.push(
					<React.Fragment key={idx}>
						<StyledTableRow hover={true}
							onClick={()=>{
								var completed = propsComp;
								var reqs = propsReq;
								var needToComplete = [];
							
								var allComplete = true;
								for(var i = 0; i < reqs.length; i++) {
								  var atLeastOne = false;
								  for(var j = 0; j < reqs[i].length; j++) {
									// preReq completed
									if(completed.includes(reqs[i][j])) {
									  atLeastOne = true;
									  break;
									}
									allComplete = false;
								  }
							
								  if(atLeastOne === false) {
									// suggest the user to complete at least one in the list
									needToComplete.push(reqs[i]);
									openNotification1("hello world");
								  }
								}
								
								addCartCourse({
									course: courseKey,
									section: idx
								})
							}} 
						>
							<StyledTableCell style={bold}>{sect.number.replace('_',' ')}</StyledTableCell >
							<StyledTableCell style={bold}>{sect.instructor}</StyledTableCell >
							<StyledTableCell style={bold}>{sect.location}</StyledTableCell >
							<StyledTableCell  
								style={bold}
							>
								{stringifyTime(sect.time)}
							</StyledTableCell >
						</StyledTableRow>
						<Subsection 
							Section={sect.subsections} 
							data={propsData}
							name={name} 
							num={num} 
							sect={sect} 
							callbackFromSubsection={callbackFromSection} 
							courseKey={courseKey} 
							addCartCourse={(data) => addCartCourse(data)} 
							sectIdx={idx}
							completedCourses={propsComp}
						>
						</Subsection>
					</React.Fragment>
				)
			});
			
			// generate the header of table and hook the rows made above
			return(
				<React.Fragment>
					<TableContainer component={Paper}>
						<Table size='small'>
						<TableHead>
							<TableRow style={{'minWidth': '700'}}>
								<StyledTableCell>Section</StyledTableCell>
								<StyledTableCell>Instructor</StyledTableCell>
								<StyledTableCell>Location</StyledTableCell>
								<StyledTableCell>Time</StyledTableCell>
							</TableRow>
						</TableHead>

						<TableBody>
							{rows}
						</TableBody>
						</Table>
					</TableContainer>
				</React.Fragment>
			)
		}

		// actual return
		return (
			<React.Fragment>
				{generateSections(this.props.Sections, this.props.name, this.props.num, this.props.callbackFromSection, this.props.courseKey, this.props.addCartCourse, this.props.completedCourses.data, this.props.data.requisites, this.props.data)}
			</React.Fragment>
		)
	}
}

export default Section;